import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fetchDefault } from './Utils.js';
import { useHistory } from "react-router-dom";


const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(1),
        width: 200,
    },
    menu: {
        width: 180,
    },
}));



export default function ChangeJWT(props) {
    const classes = useStyles();
    let history = useHistory();


    useEffect(() => {
        fetchDefault('/User/ChangeJWT?jwt=' + props.match.params.jwt,
            (data) => {
                history.push('/');
            }
        );

        return () => {
        }
    }, []);

    return (
        <div>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/ChangeJWT.js